import styled from 'styled-components';

export const ResultsCheckVinContainer = styled.div`
  border-bottom: 1px solid #39444f1a;
  padding: 18px 17px 17px 17px;
  margin-bottom: 18px;
  margin-left: -17px;
  margin-right: -17px;
  margin-top: -18px;
  background: #fff8e7;
  box-sizing: border-box;
  background: ${(props) => (props.isValid ? '#fff8e7' : '#f1ffe8')};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  @media (max-width: 512px) {
    border-radius: 0px;
    padding: 16px 6px 16px 8px;
    margin-left: -8px;
    margin-right: -8px;
    margin-bottom: 18px;
  }

  .results-descr-container {
    margin-top: 5px;
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 867px) {
      flex-direction: column;
    }
  }

  .results-descr-block {
    margin-right: 24px;
  }

  .date-creation {
    display: inline-block;
    margin-top: 6px;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.regent};
  }

  & .results-descr {
    align-items: center;
    width: 45%;
    white-space: pre;
    margin-right: 20px;
    @media (max-width: 1024px) {
      width: 35%;
    }
  }

  & .results-descr > div {
    font-size: 14px;
    line-height: 2.5;
  }

  .open-full-report_btn {
    margin-top: 14px;
  }
`;

export const Header = styled.div`
  font-size: 20px;
  font-weight: bold;

  @media (max-width: 512px) {
    font-size: ${({ theme }) => theme.fontSize.xn};
  }
  @media (max-width: 400px) {
    max-width: 180px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 512px) {
    .autocod-icon {
      width: 80px;
      padding-right: 2px;
    }
  }
`;

export const ResultsCheckDescr = styled.div``;
